import {
  HANDLE_CHANGE_BECHMARK_FILTERING,
  HANDLE_CHANGE_SAMPLE_COMMENTS_FILTER,
  //table
  FETCH_TOTAL_FEEDBACK_PROVIDERS_START,
  FETCH_TOTAL_FEEDBACK_PROVIDERS_SUCCESS,
  FETCH_TOTAL_FEEDBACK_PROVIDERS_FAIL,
  //bar chart
  FETCH_DEV_AND_STRENGTH_VISUALIZATION_START,
  FETCH_DEV_AND_STRENGTH_VISUALIZATION_SUCCESS,
  FETCH_DEV_AND_STRENGTH_VISUALIZATION_FAIL,
  //pieChart
  FETCH_CANT_ANSWER_VISUALIZATION_START,
  FETCH_CANT_ANSWER_VISUALIZATION_SUCCESS,
  FETCH_CANT_ANSWER_VISUALIZATION_FAIL,
  //
  FETCH_TOP_STRENGTH_TOP_DEV_START,
  FETCH_TOP_STRENGTH_TOP_DEV_SUCCESS,
  FETCH_TOP_STRENGTH_TOP_DEV_FAIL,
  //
  FETCH_RATER_HEATMAP_START,
  FETCH_RATER_HEATMAP_SUCCESS,
  FETCH_RATER_HEATMAP_FAIL,
  //
  FETCH_BENCHMARK_KPI_TILES_START,
  FETCH_BENCHMARK_KPI_TILES_SUCCESS,
  FETCH_BENCHMARK_KPI_TILES_FAIL,
  //
  FETCH_SELF_VS_OTHERS_START,
  FETCH_SELF_VS_OTHERS_SUCCESS,
  FETCH_SELF_VS_OTHERS_FAIL,
  //
  FETCH_DISTRIBUTION_STRIP_START,
  FETCH_DISTRIBUTION_STRIP_SUCCESS,
  FETCH_DISTRIBUTION_STRIP_FAIL,
  //
  FETCH_RANK_DELTA_START,
  FETCH_RANK_DELTA_SUCCESS,
  FETCH_RANK_DELTA_FAIL,
  //
  FETCH_COMMENTS_AND_GIST_START,
  FETCH_COMMENTS_AND_GIST_SUCCESS,
  FETCH_COMMENTS_AND_GIST_FAIL,
  //
  FETCH_ORG_RATER_GROUPS_START,
  FETCH_ORG_RATER_GROUPS_SUCCESS,
  FETCH_ORG_RATER_GROUPS_FAIL,
  //
  FETCH_BENCHMARK_TAXONOMY_START,
  FETCH_BENCHMARK_TAXONOMY_SUCCESS,
  FETCH_BENCHMARK_TAXONOMY_FAIL,
  //org data
  FETCH_ORGANIZATION_SETTINGS_START,
  FETCH_ORGANIZATION_SETTINGS_SUCCESS,
  FETCH_ORGANIZATION_SETTINGS_FAIL,

  ///

  FETCH_ALIGNMENT_SCORE_START,
  FETCH_ALIGNMENT_SCORE_SUCCESS,
  FETCH_ALIGNMENT_SCORE_FAIL,

  SAVE_ORG_FILTER_SETTINGS_START,
  SAVE_ORG_FILTER_SETTINGS_SUCCESS,
  SAVE_ORG_FILTER_SETTINGS_FAIL,

  FETCH_SURVEYS_LIST_FOR_ORG_START,
  FETCH_SURVEYS_LIST_FOR_ORG_SUCCESS,
  FETCH_SURVEYS_LIST_FOR_ORG_FAIL,
  REASSIGN_SAVED_DATA
} from "../../constants";
import { Default } from "./InitialState/index";

import { handleVisualizationStateFail, handleVisualizationStateSuccess, handleVisualizationStateStart, handleChangeBechmarkFiltering, handleChangeSampleCommentsFilter, handleCommentsAndGistStart, handleCommentsAndGistSuccess, handleCommentsAndGistFail, fetchOrganizationConfigurationStart, fetchOrganizationConfigurationSuccess, fetchOrganizationConfigurationFail, updateOrgConfigurationsStart, updateOrgConfigurationsSuccess, updateOrgConfigurationsFail, fetchSurveyListsStart, fetchSurveyListsSuccess, fetchSurveyListsFail, fetchOrgRaterGroupsStart, fetchOrgRaterGroupsSuccess, fetchOrgRaterGroupsFail, fetchBenchmarkTaxonomyStart, fetchBenchmarkTaxonomySuccess, fetchBenchmarkTaxonomyFail, handleReassignExistingData } from "./Helper";

const BenchmarkFilteringReducer = (state = Default(), action) => {
  switch (action.type) {

    case HANDLE_CHANGE_BECHMARK_FILTERING:
      return handleChangeBechmarkFiltering(state, action.payload);

    case HANDLE_CHANGE_SAMPLE_COMMENTS_FILTER:
      return handleChangeSampleCommentsFilter(state, action.payload);

    case FETCH_TOTAL_FEEDBACK_PROVIDERS_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchTotalFeedbackProvidersApi" });
    case FETCH_TOTAL_FEEDBACK_PROVIDERS_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchTotalFeedbackProvidersApi" });
    case FETCH_TOTAL_FEEDBACK_PROVIDERS_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchTotalFeedbackProvidersApi" });

    case FETCH_DEV_AND_STRENGTH_VISUALIZATION_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchTotalFeedbackProvidersStrengthAndDevApi" });
    case FETCH_DEV_AND_STRENGTH_VISUALIZATION_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchTotalFeedbackProvidersStrengthAndDevApi" });
    case FETCH_DEV_AND_STRENGTH_VISUALIZATION_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchTotalFeedbackProvidersStrengthAndDevApi" });

    case FETCH_CANT_ANSWER_VISUALIZATION_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchCantAnswerResponseApi" });
    case FETCH_CANT_ANSWER_VISUALIZATION_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchCantAnswerResponseApi" });
    case FETCH_CANT_ANSWER_VISUALIZATION_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchCantAnswerResponseApi" });

    case FETCH_TOP_STRENGTH_TOP_DEV_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchTopStrengthAndTopDevApi" });
    case FETCH_TOP_STRENGTH_TOP_DEV_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchTopStrengthAndTopDevApi" });
    case FETCH_TOP_STRENGTH_TOP_DEV_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchTopStrengthAndTopDevApi" });

    case FETCH_RATER_HEATMAP_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchRaterHeatmapApi" });
    case FETCH_RATER_HEATMAP_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchRaterHeatmapApi" });
    case FETCH_RATER_HEATMAP_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchRaterHeatmapApi" });

    case FETCH_BENCHMARK_KPI_TILES_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchBenchmarkKpiTilesApi" });
    case FETCH_BENCHMARK_KPI_TILES_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchBenchmarkKpiTilesApi" });
    case FETCH_BENCHMARK_KPI_TILES_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchBenchmarkKpiTilesApi" });

    case FETCH_SELF_VS_OTHERS_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchSelfVsOthersApi" });
    case FETCH_SELF_VS_OTHERS_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchSelfVsOthersApi" });
    case FETCH_SELF_VS_OTHERS_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchSelfVsOthersApi" });

    case FETCH_DISTRIBUTION_STRIP_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchDistributionStripApi" });
    case FETCH_DISTRIBUTION_STRIP_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchDistributionStripApi" });
    case FETCH_DISTRIBUTION_STRIP_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchDistributionStripApi" });

    case FETCH_RANK_DELTA_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchRankDeltaApi" });
    case FETCH_RANK_DELTA_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchRankDeltaApi" });
    case FETCH_RANK_DELTA_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchRankDeltaApi" });



    case FETCH_ALIGNMENT_SCORE_START:
      return handleVisualizationStateStart(state, { ...action.payload, apiName: "fetchBenchmarkAlignmentScoreApi" });
    case FETCH_ALIGNMENT_SCORE_SUCCESS:
      return handleVisualizationStateSuccess(state, { ...action.payload, apiName: "fetchBenchmarkAlignmentScoreApi" });
    case FETCH_ALIGNMENT_SCORE_FAIL:
      return handleVisualizationStateFail(state, { ...action.payload, apiName: "fetchBenchmarkAlignmentScoreApi" });

    case FETCH_COMMENTS_AND_GIST_START:
      return handleCommentsAndGistStart(state, action.payload);
    case FETCH_COMMENTS_AND_GIST_SUCCESS:
      return handleCommentsAndGistSuccess(state, action.payload);
    case FETCH_COMMENTS_AND_GIST_FAIL:
      return handleCommentsAndGistFail(state, action.payload);

    case FETCH_ORG_RATER_GROUPS_START:
      return fetchOrgRaterGroupsStart(state, action.payload);
    case FETCH_ORG_RATER_GROUPS_SUCCESS:
      return fetchOrgRaterGroupsSuccess(state, action.payload);
    case FETCH_ORG_RATER_GROUPS_FAIL:
      return fetchOrgRaterGroupsFail(state, action.payload);

    case FETCH_BENCHMARK_TAXONOMY_START:
      return fetchBenchmarkTaxonomyStart(state, action.payload);
    case FETCH_BENCHMARK_TAXONOMY_SUCCESS:
      return fetchBenchmarkTaxonomySuccess(state, action.payload);
    case FETCH_BENCHMARK_TAXONOMY_FAIL:
      return fetchBenchmarkTaxonomyFail(state, action.payload);


    case FETCH_ORGANIZATION_SETTINGS_START:
      return fetchOrganizationConfigurationStart(state, action.payload);
    case FETCH_ORGANIZATION_SETTINGS_SUCCESS:
      return fetchOrganizationConfigurationSuccess(state, action.payload);
    case FETCH_ORGANIZATION_SETTINGS_FAIL:
      return fetchOrganizationConfigurationFail(state, action.payload);

    case SAVE_ORG_FILTER_SETTINGS_START:
      return updateOrgConfigurationsStart(state, action.payload);
    case SAVE_ORG_FILTER_SETTINGS_SUCCESS:
      return updateOrgConfigurationsSuccess(state, action.payload);
    case SAVE_ORG_FILTER_SETTINGS_FAIL:
      return updateOrgConfigurationsFail(state, action.payload);

    case FETCH_SURVEYS_LIST_FOR_ORG_START:
      return fetchSurveyListsStart(state, action.payload);
    case FETCH_SURVEYS_LIST_FOR_ORG_SUCCESS:
      return fetchSurveyListsSuccess(state, action.payload);
    case FETCH_SURVEYS_LIST_FOR_ORG_FAIL:
      return fetchSurveyListsFail(state, action.payload);

    case REASSIGN_SAVED_DATA:
      return handleReassignExistingData(state, action.payload)


    default:
      return { ...state };
  }
};

export default BenchmarkFilteringReducer;
